import React from 'react';

function CrmDualModeTabs({
  activeMode, // 'new' | 'existing'
  onChange,
  newLabel = 'Create new',
  existingLabel = 'Add existing',
}) {
  return (
    <div
      className="d-inline-flex"
      role="tablist"
      aria-label="Dual mode selector"
      style={{
        borderRadius: 8,
        overflow: 'hidden',
        border: '1px solid var(--sl-border-secondary)',
      }}
    >
      <button
        type="button"
        className="btn btn-sm"
        style={{
          borderRadius: 0,
          border: 'none',
          backgroundColor: activeMode === 'new' ? 'var(--sl-bg-primary)' : 'var(--sl-bg-primary-alt)',
          color: activeMode === 'new' ? 'var(--sl-text-primary)' : 'var(--sl-text-tertiary)',
          fontWeight: activeMode === 'new' ? 600 : 500,
          padding: '6px 16px',
        }}
        aria-selected={activeMode === 'new'}
        onClick={() => onChange('new')}
      >
        {newLabel}
      </button>
      <button
        type="button"
        className="btn btn-sm"
        style={{
          borderRadius: 0,
          borderLeft: '1px solid var(--sl-border-secondary)',
          backgroundColor: activeMode === 'existing' ? 'var(--sl-bg-primary)' : 'var(--sl-bg-primary-alt)',
          color: activeMode === 'existing' ? 'var(--sl-text-primary)' : 'var(--sl-text-tertiary)',
          fontWeight: activeMode === 'existing' ? 600 : 500,
          padding: '6px 16px',
        }}
        aria-selected={activeMode === 'existing'}
        onClick={() => onChange('existing')}
      >
        {existingLabel}
      </button>
    </div>
  );
}

export default CrmDualModeTabs;
